// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__2ls6z","info":"Note_info__1zFbH","note":"Note_note__3znlZ","actions":"Note_actions__15q7C"};